import React from 'react'
import FinancialLotteryReportList from '../components/FinancialLotteryReportList'
import FinancialReportShell from '../components/FinancialReportShell'

const FinancialReportBettingPage: React.FC = () => {
  return (
    <FinancialReportShell activeTab="settled">
      <FinancialLotteryReportList mode="settled" />
    </FinancialReportShell>
  )
}

export default FinancialReportBettingPage
